import {Chart} from 'chart.js/auto';

const charts = {};

window.renderChart = function (element, data) {
    if (charts[element.id]) {
        const chart = charts[element.id];

        chart.data = data;

        chart.update();

        return;
    }

    charts[element.id] = new Chart(element, {
        type: 'line',
        data: data,
        options: {
            scales: {
                x: {
                    stacked: false,
                },
                y: {
                    stacked: false,
                },
            },
            plugins: {
                legend: {
                    position: 'top',
                },
            },
            tooltip: {
                position: 'average',
            },
            responsive: true,
            aspectRatio: 16 / 9,
            resizeDelay: 300,
            interaction: {
                mode: 'index',
                intersect: false,
            },
        },
    });
};
